<!--
  This component was disigned to be used with report_totals_box.
-->
<template>
  <div class="row" style="padding:4px 0px;">
    <div class="col-xs-1" v-if="this.$props['labelSize'] != 'L' "/>
    <div :class="labelClass" style="padding: 0px;">
      <label class="control-label lams_inventory_form_label"
      >{{fieldLabel}}</label>
    </div>
    <div class="col-xs-5">
      <input class="lams_inventory_form_control"
      style="    text-align: end;"
      :value="fieldValue"
      readonly />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import debug from "debug";
var debug_search_control = debug("esma:input-box-result");
export default {
  components: {},
  data() {
    return {
    };
  },
  computed: {
    labelClass(){
      return (this.$props["labelSize"] == "L")?"col-xs-7":"col-xs-4"
    },
    fieldValue(){
      return this.$props.value;
    },
    fieldLabel(){
      return this.$props.label;
    },
  },
  methods: {

  },
  beforeMount() {},
  mounted() {
    // this.$props.data.ref_field = this;
  },
  afterMount() {},
  beforeDestroy() {},
  props: ["value","label","label-size"],
};
</script>

<style scoped>
.lams_inventory_form_label {
  margin: 2px 0px !important;
  /* padding: 4px !important; */
  /* font-size: 11px !important; */
  /* text-align: center !important; */
}
.lams_inventory_form_control {
  height: 24px !important;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// input-box-result.vue?6bfbc2fa